import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Badge,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../Components/promotion.css";
import OrdersPage from "./OrdersPage";

export default function PagesDetailAccordion({
  data,
  sDetailData,
  pageType,
  fGetRow,
  loadSummary
}) {
  const [expanded, setExpanded] = React.useState(null);
  const vMediaQuery = useMediaQuery("(max-width:900px)");

  const pages = sDetailData?.pageData ?? [];

  const handleChange = (panelKey) => (_e, isExpanded) =>
    setExpanded(isExpanded ? panelKey : null);

  return (
    <Box>
      {pages.map((page, idx) => {
        const panelKey = `panel-${idx}`;
        // DataGrid rows need a unique "id" field
        const rows = page.subData || [];
        const validRows = rows.filter((r) => r.Category !== null);

        // Show badge only when validRows.length > 0
        const showBadge = validRows.length > 0;
        return (
          <Box className="pages" key={panelKey}>
            <Accordion
              key={panelKey}
              expanded={expanded === panelKey}
              onChange={handleChange(panelKey)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: vMediaQuery ? "60%" : "50%",
                  }}
                >
                  <Typography fontWeight={600}>{page.Title}</Typography>

                  {showBadge && (
                    <Box textAlign={"center"}>
                      <Badge
                        badgeContent={validRows.length}
                        color="success"
                      ></Badge>
                    </Box>
                  )}
                </Box>
              </AccordionSummary>

              <AccordionDetails>
                <Box>
                  <OrdersPage
                    rows={validRows}
                    data={data}
                    pageType={pageType}
                    fGetRow={fGetRow}
                    loadSummary={loadSummary}
                  />
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        );
      })}
    </Box>
  );
}
